export enum IDWAppAlertTypes {
    SUCCESS = "SUCCESS",
    ERROR = "ERROR"
}